import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/utils/gtm";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView({
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
};

export default RouteTracker;
